module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.linkTag, _vm._b({
    tag: "component",
    class: _vm.linkClass,
    domProps: {
      "innerHTML": _vm._s(_vm.labelSet)
    },
    on: {
      "click": _vm.onClick
    }
  }, 'component', _vm.linkProps, false))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-361e11d1"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/Link.vue
// module id = 262
// module chunks = 2